import apiClient from './client';

export const purchaseGolden = async (genericName) => {
  const res = await apiClient.post('/api/golden/purchase', { generic_name: genericName });
  return res.data;
};

export const getReservoir = async () => {
  const res = await apiClient.get('/api/golden/reservoir');
  return res.data;  // array of reservoir entries with user_status, can_purchase
};

export const deleteReservoirEntry = async (genericName) => {
  const res = await apiClient.delete(`/api/golden/reservoir/${encodeURIComponent(genericName)}`);
  return res.data;  // { deleted: genericName }
};

export const getSynergyRegistry = async () => {
  const res = await apiClient.get('/api/golden/synergy-registry');
  return res.data;
};
